/*=========================================================================================
  File Name: module-agreement-actions.js
  Description: LicenseAgreement Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import LicenseAgreementAPI from '@/api/LicenseAgreementAPI.js';
import commonFunc from '@/common/commonFunction';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import { MSEnum } from '../../common/enumeration';
import DateUtil from '@/utils/dateUtil';

export default {
	loadAgreement: async function(context, payload) {
		let fn = async function(payload) {
			let res = await httpClient.getAsync({
				url: LicenseAgreementAPI.getAPIUrlSubParam(commonFunc.getSubParam()),
				params: payload
			});
			if (res && res.Data) {
				context.commit('updateTermOfUseResult', { Data: res.Data, TimeStamp: new Date() });
			}
			return res;
		};

		if (Object.keys(context.state.TermOfUseResult).length == 0) {
			return await fn(payload);
		} else {
			let time = DateUtil.getAmountDay(context.state.TermOfUseResult.TimeStamp, new Date());
			//nếu đã lấy thông tin license trong phạm vi 1 ngày thì trả ra luôn không thì load lại từ server
			if (time == 0) {
				return context.state.TermOfUseResult.Data;
			} else {
				return await fn(payload);
			}
		}
	},

	acceptAgreement: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: LicenseAgreementAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/accept`,
				params: payload
			},
			true
		);
		return res;
	},

	confirmTermOfUse: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: LicenseAgreementAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/confirm-termofuse`,
				data: payload
			},
			true
		);
		if (res && res.Data) {
			context.commit('updateTermOfUseResult', res.Data);
		}
		return res;
	},

	viewHistoryTermOfUse: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: LicenseAgreementAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/view-history`,
			params: payload
		});
		if (res && res.Data) {
			context.commit('updateTermOfUseResult', res.Data);
		}
		return res;
	},
	/**
	 * api xem lịch sử mua hàng
	 * @param {*} context 
	 * @param {*} payload 
	 * @returns 
	 */
	viewHistoryTermOfPurchase: async function (context, payload) {
		let res = await httpClient.getAsync({
			url: LicenseAgreementAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/view-history-purchase`,
			params: payload
		});
		if (res && res.Data) {
			context.commit('updateTermOfUseResult', res.Data);
		}
		return res;
	},

	getFileTermOfUse: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: LicenseAgreementAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/termofuse-file`,
			params: payload
		});
		if (res && res.Data) {
			context.commit('updateTermOfUseResult', res.Data);
		}
		return res;
	},

	getPublishKey: async function(context) {
		const subParam = commonFunc.getSubParam();
		if (!subParam || subParam.indexOf('undefined') !== -1) return null;
		let res = await httpClient.getAsync({
			url: LicenseAgreementAPI.getAPIUrlSubParam(subParam) + '/publish-key'
		});
		return res && res.Data ? res.Data : null;
	}
};
